﻿import { apiClient } from '@/api/apiClient';
import type { Client, CurrentClientInfo } from './types';

/**
 * Fetches the current user's own client info including the isOriginUser flag.
 * Calls GET /client — available to all authenticated users (no OriginUser policy).
 */
export async function fetchCurrentClient(): Promise<CurrentClientInfo> {
    const response = await apiClient.get<CurrentClientInfo>('/client');
    return response.data;
}

/**
 * Fetches the list of all accessible clients from the backend.
 * Calls GET /clients — protected by OriginUser policy (Origin staff only).
 * The Authorization header is injected automatically by the apiClient interceptor.
 */
export async function fetchClients(): Promise<Client[]> {
    const response = await apiClient.get<Client[]>('/clients');
    return response.data;
}
